import styled from '@emotion/styled';

export default styled.div`
    padding: 2em 0;

    h2.jobs-title {
        font-size: 2em;
        font-weight: 700;
    }

    .job {
        padding: 2em 0;
        border-top: .01em solid #000000;

        &:last-child {
            margin-bottom: 1.5em;
            border-bottom: .01em solid #000000;
        }

        .job-name {
            font-size: 1.2em;
            font-weight: 700;
            margin-bottom: .8em;
            max-width: 40ch;
        }

        .job-info {
            display: flex;
            justify-content: space-between;

            .job-company {
                font-size: 1.2em;
                margin-right: auto;
                margin-bottom: 0;
            }

            .job-agreement,
            .job-time,
            .job-city {
                font-size: 1em;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 1em;
                margin-bottom: 0;

                &:not(:last-child) {
                    margin-right: 2em;
                }
            }
        }
    }

`;